export default {
  discount: 'discount',
  floorArea: 'floorArea',
  gradeSort: 'gradeSort',
  name: 'name',
  random: 'random',
  price: 'sortPrice',
};
